// extracted by mini-css-extract-plugin
export default {"bodyContainer":"styles_bodyContainer__e81a-","card":"styles_card__lOXJi"};